// extracted by mini-css-extract-plugin
export var icon = "_6u-1";
export var subtext = "_6u-0";